interface Props {
  step: 2 | 3 | 4 | 5;
  stepLabel: string;
  onBack: () => void;
}

export function PlaceholderStep({ step, stepLabel, onBack }: Props) {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-brand-ink">
        Step {step}: {stepLabel}
      </h2>
      <p className="text-sm text-brand-muted">This step is coming soon.</p>
      <button
        onClick={onBack}
        className="text-sm text-brand-muted hover:text-brand-ink inline-flex items-center gap-1"
      >
        ← Back
      </button>
    </div>
  );
}
